import React, { useState, useEffect } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var Facturation = function Facturation() {
  return /*#__PURE__*/_jsx(_Fragment, {});
};

export default Facturation;